import { connect } from 'react-redux'
import ConnectedPageSearch from 'pages/search/ConnectedPageSearch'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  aol: state.aol.name,
  searchType: state.search.searchType,
  searchPhrase: state.search.searchPhrase,
  pageNumber: state.search.pageNumber,
  pageLimit: state.search.pageLimit,
  query: state.search.query
})

export default connect(mapStateToProps, null)(ConnectedPageSearch)
